import {
    FETCH_CARD_ISSUED_COUNT,
    FETCH_CARD_ISSUED_COUNTS,
    REMOVE_CARD_ISSUED_COUNTS
} from '../actions/types';

const initialState = {
    items: [],
    currentItem: null,
    pagination: { currentPage: 1, total: 0, perPage: 30 }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CARD_ISSUED_COUNTS:
            return {
                ...state,
                items: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 30, 10)
                }
            };
        case FETCH_CARD_ISSUED_COUNT:
            return { ...state, currentItem: action.payload || null };
        case REMOVE_CARD_ISSUED_COUNTS:
            return {
                ...state,
                items: state.items.filter(item => !action.payload.includes(item.id))
            };
        default:
            return state;
    }
};
